import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import '../i18n';
import DrawerSide from '../stories/layout-components/DrawerSide';
import { TextField } from '../stories/general-components/TextField';
import { Button } from '../stories/general-components/Button';
import { GeneralText } from '../stories/general-components/GeneralText';
import nodeAxiosFirebase from '../utils/nodeAxiosFirebase';
import { useParams, useNavigate } from 'react-router-dom';

const NodeAIWorkshop = ({ closeSidebar, locationId, isDrawerOpen, handleDrawerClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { moduleName, moduleId, structureId } = useParams();
  const currentUser = useSelector((state) => state.core.user);
  const businessPreference = useSelector((state) => state.core.businessData);
  const singleElementDetails = useSelector(
    (state) => state.element.singleElementDetails
  );

  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const simulateAIResponse = (userMessage) => {
    setTimeout(() => {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: `ai-${Date.now()}`,
          text: `${userMessage}`,
          sender: 'ai',
        },
      ]);
    }, 1000);
  };





  const handleSendMessage = async () => {

    if (inputValue.trim() === '') return;

    const newMessage = {
      id: `user-${Date.now()}`,
      text: inputValue,
      sender: 'user',
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    setInputValue('');
    try {
      const responseIA = await nodeAxiosFirebase({
        t,
        method: 'POST',
        url: `chekup/ai`,
        body: {
          message: inputValue,
          messages: messages,
          documentPath: singleElementDetails?.documentPath,
          collection: moduleName
        },
      });
      simulateAIResponse(responseIA);
    } catch (error) {
      console.error('Error in ai:', error.message, error);
    }
  }


  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    const chatMessagesDiv = document.getElementById('chat-messages-workshop');
    if (chatMessagesDiv) {
      chatMessagesDiv.scrollTop = chatMessagesDiv.scrollHeight;
    }
  }, [messages]);

  return (
    <DrawerSide
      title={t('nodeAI')}
      position='right'
      handleDrawerClose={closeSidebar}
      isDrawerOpen={isDrawerOpen}
      isCreation={true}
      width={'450px'}
    >
      <div className="flex flex-col h-full p-3 bg-gray-100 dark:bg-gray-800">
        {/* Chat messages area */}
        <div
          id="chat-messages-workshop"
          className="flex-grow overflow-y-auto mb-4 p-3 bg-white dark:bg-gray-700 rounded-md "
          style={{ maxHeight: 'calc(100vh - 150px)' }}
        >
          {messages?.length === 0 && (
            <GeneralText
              text={t('nodeAIWorkshop.noMessages', 'No messages yet. Start the conversation!')}
              primary={true}
            />
          )}
          {messages?.map((msg) => (
            <div
              key={msg.id}
              className={`mb-1 p-3 rounded-lg max-w-xs lg:max-w-md xl:max-w-lg break-words ${msg.sender === 'user'
                ? 'bg-blue-500 text-white ml-auto'
                : 'bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-gray-200 mr-auto'
                }`}
            >
              <GeneralText text={msg.text} primary={true} />
            </div>
          ))}
        </div>

        {/* Input area */}
        <div className="flex items-start border-t border-gray-300 dark:border-gray-600 pt-3">
          <TextField
            value={inputValue}
            onChange={handleInputChange}
            handleKeyPress={handleKeyPress}
            placeholder={t('typeMessage')}
            multiline
            rows={2}
            variant="outlined"
            fullWidth
            sx={{
              mr: 1,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'gray',
                },
                '&:hover fieldset': {
                  borderColor: 'blue',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'blue',
                },
                backgroundColor: 'white',
                color: 'black',
              },
              '& .MuiInputBase-inputMultiline': {
                color: 'black',
              },
              '.dark & .MuiOutlinedInput-root': {
                backgroundColor: 'gray.700',
                color: 'white',
                '& fieldset': {
                  borderColor: 'gray.500',
                },
              }
            }}
          />
          <Button
            label={t('send')}
            onClick={handleSendMessage}
            disabled={!inputValue.trim()}
            variant="contained"
            noShadow
            fullWidth
          />
        </div>
      </div>
    </DrawerSide>
  );
};

export default NodeAIWorkshop;
